import React from "react";
import { useTranslation } from "react-i18next";
import PathLink from "../../shared/seo/PathLink";
import { urls, copy, currentLang } from "../../shared/seo/links";
import { citiesOf } from "./contentLinks";
import "./content.css";

// "Find a lawyer in your city": the national directory and the biggest cities.
export default function FindLawyerBlock({ cities }) {
  const { t } = useTranslation();
  const lang = currentLang();
  return (
    <section className="avc-find-lawyer" aria-labelledby="avc-find-lawyer-title">
      <span className="avc-find-lawyer__icon" aria-hidden="true">
        <i className="fas fa-balance-scale"></i>
      </span>
      <div className="avc-find-lawyer__body">
        <h2 className="avc-find-lawyer__title" id="avc-find-lawyer-title">
          {t("find_lawyer_title")}
        </h2>
        <p className="avc-find-lawyer__text">{t("find_lawyer_text")}</p>
        <ul className="avc-find-lawyer__links">
          <li>
            <PathLink to={urls.lawyersPath(lang)} className="avc-find-lawyer__all">
              {t("find_lawyer_all")}
            </PathLink>
          </li>
          {citiesOf(cities).map((gov) => (
            <li key={gov.key}>
              <PathLink to={urls.lawyersPath(lang, { governorate: gov })}>
                {copy.lawyers(lang, { governorate: gov }).h1}
              </PathLink>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
